<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { isToday, isYesterday } from 'date-fns';

  const props = defineProps({
    validDate: {
      type: String,
      required: true
    },
    timezone: {
      type: String,
      required: true
    }
  });

  const { t } = useI18n();

  const morningOf = computed(() => {
    const date = new Date(`${props.validDate} ${props.timezone}`);

    return isToday(date) ? t('containers.proForecast.tomorrowMorning') : isYesterday(date) ? t('containers.proForecast.thisMorning') : t('containers.proForecast.tomorrowMorning');
  });

</script>
<template>
  <div class="jwx-pro-forecast__body">
    <section class="jwx-page__section">
      <div class="jwx-pro-forecast__block jwx-block">
        <div class="jwx-block__body-content">
          <p class="jwx-pro-forecast__text" data-size="lg">{{ t('containers.proForecast.freshForecast', { morningOf }) }}</p>
          <p class="jwx-pro-forecast__text" data-size="lg"> {{ t('containers.proForecast.checkBack', { morningOf }) }}</p>
        </div>
      </div>
    </section>
  </div>
</template>